// ================================================
// --------------------定数---------------------
// ================================================
export const baseId = "molecule-game-boy-logo";
export const UIMODE_OPENING        = "opening";
export const UIMODE_CALUCSELECT    = "calcselect";
export const UIMODE_SELECT         = "modeSelect";
export const UIMODE_MAIN           = "main";
export const UIMODE_TITLE          = "title";
export const UIMODE_START          = "start";
export const UIMODE_KANJI_GAME     = "kanji";
export const UIMODE_GAKUNEN_SELECT = "gakunenSelect";
export const UIMODE_POKEMON_ZUKAN  = "zukan";
export const UIMODE_TYPING_GAME    = "typing";
export const UIMODE_COUNTDOWN      = "countdown";
export const UIMODE_TYPING_MAIN    = "typingMain";
export const UIMODE_TYPING_END     = "typingEnd";
export const TEST_MODE = "test";

// ================================================
// BGM / SE
// ================================================
export const MUSIC_OPENING =
    "https://firebasestorage.googleapis.com/v0/b/simpletypinggame.appspot.com/o/MUSIC%2F01%20%EF%BD%9E%E3%82%AA%E3%83%BC%E3%83%95%E3%82%9A%E3%83%8B%E3%83%B3%E3%82%AF%E3%82%99%EF%BD%9E.wav?alt=media&token=51d966d0-66c9-49f4-bbd7-14809288d135";
export const MUSIC_GAME =
    "https://firebasestorage.googleapis.com/v0/b/simpletypinggame.appspot.com/o/MUSIC%2F21%20%E3%83%9E%E3%82%B5%E3%82%AD%E3%81%AE%E3%82%82%E3%81%A8%E3%81%B8%EF%BC%8D%E3%83%8F%E3%83%8A%E3%82%BF%E3%82%99%E3%82%88%E3%82%8A.wav?alt=media&token=77399b16-4558-4b95-ac73-c458c8ae3a52";
export const MUSIC_POKEMON_BATLE =
    "https://firebasestorage.googleapis.com/v0/b/simpletypinggame.appspot.com/o/MUSIC%2F07%20%E6%88%A6%E3%81%84%EF%BC%88%EF%BC%B6%EF%BC%B3%E9%87%8E%E7%94%9F%E3%83%9B%E3%82%9A%E3%82%B1%E3%83%A2%E3%83%B3%EF%BC%89.wav?alt=media&token=8dacd0f2-c1ee-4394-85e3-0eaca290ea15";
export const MUSIC_POKEMON_VICTORY =
    "https://firebasestorage.googleapis.com/v0/b/simpletypinggame.appspot.com/o/MUSIC%2F08%20%E5%8B%9D%E5%88%A9%EF%BC%88%EF%BC%B6%EF%BC%B3%E9%87%8E%E7%94%9F%E3%83%9B%E3%82%9A%E3%82%B1%E3%83%A2%E3%83%B3%EF%BC%89.wav?alt=media&token=d757071f-c712-42fa-8644-e4022c809b60";
export const MUSIC_POKEMON_KANJI_BATLE =
    "https://firebasestorage.googleapis.com/v0/b/pokemon-app-ff27a.appspot.com/o/MUSIC%2FAppMusic%2F15%20%E6%88%A6%E3%81%84%EF%BC%88%EF%BC%B6%EF%BC%B3%E3%83%88%E3%83%AC%E3%83%BC%E3%83%8A%E3%83%BC%EF%BC%89.wav?alt=media&token=1af43389-41e2-4a86-ba1d-75bca1f9c678"
export const MUSIC_POKEMON_KANJI_VICTORY =
    "https://firebasestorage.googleapis.com/v0/b/pokemon-app-ff27a.appspot.com/o/MUSIC%2FAppMusic%2F16%20%E5%8B%9D%E5%88%A9%EF%BC%88%EF%BC%B6%EF%BC%B3%E3%83%88%E3%83%AC%E3%83%BC%E3%83%8A%E3%83%BC%EF%BC%89..wav?alt=media&token=dbfa00c3-78cf-48af-8d9c-b5e529f20b86"

// ================================================
// 選択肢配列
// ================================================
export const GAME_MODES = ["kokugo", "sansuu", "zukan", "typing"];
export const GRADES     = ["1", "2", "3", "4", "5", "6"];
export const CALC_TYPES = ["tashi", "hiki", "kake"];

// ================================================
// 画像URL
// ================================================
export const IMG_OPENING_RED =
    "https://firebasestorage.googleapis.com/v0/b/simpletypinggame.appspot.com/o/SITE_IMG%2F001_red_img.png?alt=media&token=b5388139-e5b5-4e30-ae73-9a2160ccf351";
export const IMG_OPENING_HITOKAGE =
    "https://firebasestorage.googleapis.com/v0/b/simpletypinggame.appspot.com/o/SITE_IMG%2F002_%E3%83%92%E3%83%88%E3%82%AB%E3%82%B2.png?alt=media&token=a6bb7de0-9ac6-4ea6-8dd1-eae983d5db96";
// ボール画像URL
export const IMG_MONSTER_BALL =
    "https://firebasestorage.googleapis.com/v0/b/simpletypinggame.appspot.com/o/SITE_IMG%2F01_MAINPAGE%2F%E3%83%A2%E3%83%B3%E3%82%B9%E3%82%BF%E3%83%BC%E3%83%9C%E3%83%BC%E3%83%AB.png?alt=media&token=2ddd598b-024e-4483-86e7-031fd66b9454";
export const IMG_SUPER_BALL =
    "https://firebasestorage.googleapis.com/v0/b/pokemon-app-ff27a.appspot.com/o/IMG%2F%E3%82%B9%E3%83%BC%E3%83%91%E3%83%BC%E3%83%9C%E3%83%BC%E3%83%AB.png?alt=media&token=670c98e3-a922-41e8-8725-43c3749c0203";
export const IMG_HYPER_BALL =
    "https://firebasestorage.googleapis.com/v0/b/pokemon-app-ff27a.appspot.com/o/IMG%2F%E3%83%8F%E3%82%A4%E3%83%91%E3%83%BC%E3%83%9C%E3%83%BC%E3%83%AB.png?alt=media&token=6b495772-aef8-4fca-8e8a-fa6e47eba672";
export const IMG_MASTER_BALL =
    "https://firebasestorage.googleapis.com/v0/b/pokemon-app-ff27a.appspot.com/o/IMG%2F%E3%83%9E%E3%82%B9%E3%82%BF%E3%83%BC%E3%83%9C%E3%83%BC%E3%83%AB.png?alt=media&token=e0aea8cd-08ca-4c98-b7af-52ec4df92afc";

// 主人公の背景
export const IMG_MAIN_CHAR_BG =
    "https://firebasestorage.googleapis.com/v0/b/pokemon-app-ff27a.appspot.com/o/IMG%2Fss_03.png?alt=media&token=41262e4f-2e30-4999-aaf8-79b93756784e" 
// モンスターボールの中身あり画像
export const IMG_BALL_ON =
    "https://firebasestorage.googleapis.com/v0/b/pokemon-app-ff27a.appspot.com/o/IMG%2F%E3%83%A2%E3%83%B3%E3%82%B9%E3%82%BF%E3%83%BC%E3%83%9C%E3%83%BC%E3%83%AB(%E6%9C%89).png?alt=media&token=688ed568-ae98-416f-9ba2-a1ba85889d9f"
// モンスターボールの中身なし画像
export const IMG_BALL_NONE =
    "https://firebasestorage.googleapis.com/v0/b/pokemon-app-ff27a.appspot.com/o/IMG%2F%E3%83%A2%E3%83%B3%E3%82%B9%E3%82%BF%E3%83%BC%E3%83%9C%E3%83%BC%E3%83%AB(%E7%84%A1).png?alt=media&token=fcbdf417-7c93-41ec-994b-741a285602a5"